import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CataloguePlanningMethod } from '../models/catalogue-planner.model';
import { CataloguePlanningService } from './catalogue-planning.service';

@Injectable({ providedIn: 'root' })
export class CatalogueMethodSettingsService {
  constructor(private readonly planning: CataloguePlanningService) {}

  /** The server's method. Unlike navigation, this does not fall back to slotting on failure. */
  async getSettings(): Promise<CataloguePlanningMethod> {
    return await firstValueFrom(this.planning.getMethod());
  }

  /** Rejects with the HTTP error untouched, so callers can read a 409's `error.data`. */
  async save(enabled: boolean): Promise<void> {
    await firstValueFrom(this.planning.saveMethod(enabled ? 'catalogue' : 'slotting'));
  }
}
